// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3ccep","cell":"ColumnAccessor_cell__1EgIX","firstCellAccent":"ColumnAccessor_firstCellAccent__hA9OP"};